/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CourseCompletionResult,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Complete Course
 */
export const createCourseCompletion = (
    courseId: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);

      return axiosClient<CourseCompletionResult>(
      {url: `/courses/${courseId}/completion`, method: 'POST', signal
    },
      );
    }




export const getCreateCourseCompletionMutationKey = () => ['createCourseCompletion'] as const;

export const getCreateCourseCompletionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseCompletion>>, TError,CreateCourseCompletionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCourseCompletion>>, TError,CreateCourseCompletionMutationVariables, TContext> => {

const mutationKey = getCreateCourseCompletionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourseCompletion>>, CreateCourseCompletionMutationVariables> = (props) => {
          const {courseId} = props ?? {};

          return  createCourseCompletion(courseId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCourseCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof createCourseCompletion>>>

    export type CreateCourseCompletionMutationError = ErrorType<SchemaValidationErrorResponse | void | StandardError>
    export type CreateCourseCompletionMutationVariables = {courseId: number}

    /**
 * @summary Complete Course
 */
export const useCreateCourseCompletion = <TError = ErrorType<SchemaValidationErrorResponse | void | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseCompletion>>, TError,CreateCourseCompletionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCourseCompletion>>,
        TError,
        CreateCourseCompletionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCourseCompletionMutationOptions(options), queryClient);
    }
